namespace $ { $mol_style_attach( "mol/example/example.view.css",
 "[mol_example] {\n\tmax-width: 100%;\n}\n"
) }